export class Condition {
    code: string;
    message: string;
    details: ConditionDetail[];
}

export class ConditionDetail {
    code: string;
    details: ConditionMessage[];
}

export class ConditionMessage {
    message: string;
}

export class ConditionDisplay {
    code: string;
    route: string;
    imgPath: string;
    title: string;
    description?: string;
    columns: string[];
    row: string[][];
    btn: string[];
    isVerticalDisplayMobile: boolean;
    constructor() {
        this.columns = [];
        this.code = '';
        this.imgPath = '';
        this.row = [];
        this.route = '';
        this.title = '';
        this.btn = [];
        this.isVerticalDisplayMobile = false;
    }
}


// WEBPACK FOOTER //
// ./src/app/model/condition/condition.model.ts